import React, { useState } from "react";

import { IconButton, Menu, MenuItem, TableCell } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import { red } from "@mui/material/colors";

import { StyledTableRow } from "../customComponent";
import EditOrganization from "./EditOrganization";
import DeleteOrganization from "./DeleteOrganization";
import EditFeatureFlag from "./EditFeatureFlag";
import { colorStyling } from "../../helpers/color";
import { useTranslation } from "react-i18next";
import { formattedDate } from "../../helpers/dateFormat";

const OrganizationItem = ({ organization }) => {
  const { t } = useTranslation("organization");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [openEdit, setOpenEdit] = useState(false);
  const [openEditFlag, setOpenEditFlag] = useState(false);

  const handleClickOpenEdit = () => setOpenEdit(true);

  const handleClickCloseEdit = () => setOpenEdit(false);

  const handleClickOpenEditFlag = () => setOpenEditFlag(true);

  const handleClickCloseEditFlag = () => setOpenEditFlag(false);

  const [openDelete, setOpenDelete] = useState(false);

  const handleClickOpenDelete = () => setOpenDelete(true);

  const handleClickCloseDelete = () => setOpenDelete(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <StyledTableRow>
      <TableCell>{organization.name}</TableCell>
      <TableCell>{organization.screenQuota ?? "-"}</TableCell>
      <TableCell>
        {organization.subscriptionEndAt
          ? formattedDate(organization.subscriptionEndAt)
          : "-"}
      </TableCell>
      <TableCell align="right">
        <IconButton
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{ color: colorStyling.black }}
        >
          <MoreHorizIcon />
        </IconButton>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleClickOpenEdit} dense>
            <EditOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
            {t("editMenuItem")}
          </MenuItem>
          <EditOrganization
            open={openEdit}
            onClose={handleClickCloseEdit}
            organization={organization}
          />

          <MenuItem onClick={handleClickOpenEditFlag} dense>
            <FlagOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
            {t("editFlagMenuItem")}
          </MenuItem>
          <EditFeatureFlag
            open={openEditFlag}
            onClose={handleClickCloseEditFlag}
            organization={organization}
          />

          <MenuItem
            sx={{ color: red[600] }}
            onClick={handleClickOpenDelete}
            dense
          >
            <DeleteOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
            {t("deleteMenuItem")}
          </MenuItem>
          <DeleteOrganization
            open={openDelete}
            onClose={handleClickCloseDelete}
            organization={organization}
          />
        </Menu>
      </TableCell>
    </StyledTableRow>
  );
};

export default OrganizationItem;
